import isEmpty from 'lodash/isEmpty';
import compact from 'lodash/compact';

import Envelope from '@decisiv/iconix/lib/components/Envelope';

import Flex from '@decisiv/ui-components/lib/components/Flex';
import Link from '@decisiv/ui-components/lib/components/Link';
import { P } from '@decisiv/ui-components/lib/components/Typography';

import ClickToCallButton from 'components/ClickToCallButton';
import PlainTextCell from 'components/PlainTextCell';
import styled from 'styled-components';

type Props = {
  rowData: Pick<SentinelTeam, 'billingContact' | 'scheduledForDeletionAt'>;
};

const FitContentClickToCallButton = styled(ClickToCallButton)`
  width: fit-content;
` as typeof ClickToCallButton;

export default function BillingContactCell({
  rowData: { billingContact, scheduledForDeletionAt },
}: Props) {
  const name = compact([
    billingContact?.firstName,
    billingContact?.lastName,
  ]).join(' ');
  const email = billingContact?.email;
  const phone = billingContact?.phone;

  const color = scheduledForDeletionAt ? 'alaskanHusky' : undefined;

  return isEmpty(compact([name, email, phone])) ? (
    <PlainTextCell color={color} />
  ) : (
    <Flex flexDirection="column">
      {name && (
        <P color={color} as="span">
          {name}
        </P>
      )}
      {email && (
        <Link
          icon={Envelope}
          size="small"
          text={email}
          to={`mailto:${email} `}
        />
      )}
      {phone && (
        <FitContentClickToCallButton name={name} phone={phone} size="small" />
      )}
    </Flex>
  );
}
